import React, { useState } from 'react';
import styled from 'styled-components';

import { ButtonTs } from '@lt/components';
import { useTranslation } from '@lt/localization';
import type { SavedTourist } from 'src/routes/Checkout/store/client/types';
import MobileMenu from '../../Fields/TouristNameField/components/MobileMenu';
import type { DocType } from '../../types';

type Props = {
  docType: DocType;
  onClickOption: () => void;
  tourists: SavedTourist[];
  className?: string;
};

const MobileSavedTourists = ({
  onClickOption,
  docType,
  tourists,
  className,
}: Props) => {
  const [showMenu, setShowMenu] = useState(false);

  const { t } = useTranslation();

  if (!tourists?.length) return null;

  return (
    <div className={className}>
      <StyledButton onClick={() => setShowMenu(true)}>
        {t('checkout.touristForm.name.chooseSavedTourist')}
      </StyledButton>
      <MobileMenu
        tourists={tourists}
        docType={docType}
        showMenu={showMenu}
        setShowMenu={setShowMenu}
        onClickOption={onClickOption}
      />
    </div>
  );
};

const StyledButton = styled(ButtonTs).attrs({ variant: 'functional' })`
  color: #007aff;
  font-size: 15px;
  line-height: 18px;
  margin-top: 4px;
  width: 100%;
  text-align: left;

  &:active {
    color: #179fe3;
  }
`;

export default MobileSavedTourists;
